export interface Background {
  color: string;
  imageLink: string;
  imageName: string;
}

export interface FontSimple {
  fontWeight: string;
  fontSize: string;
  isUpperCaseEnabled: boolean;
}

export interface Font extends FontSimple {
  fontFamily: string;
  fontColor: string;
}

export interface Border {
  borderColor: string;
  borderRadius: string;
  borderWidth: string;
}

export interface StatusColors {
  default: string;
  active: string;
  error: string;
}

export interface ButtonSetting {
  buttonStyle: string;
  borderColor: string;
  borderRadius: number;
  borderWidth: number;
}

export interface Button {
  buttonStyle: string;
  text: Font;
  background: Background;
  border: Border;
}

export interface Icon {
  iconName: string;
  iconColor: string;
  iconSize: string;
}

export interface Shadow {
  blur: string;
  color: string;
  xValue: string;
  yValue: string;
}

export interface IconButton extends Button {
  icon: Icon;
}

export interface FieldParamas {
  isVisible: boolean;
  isEditable: boolean;
  addEnabled: boolean;
}

export interface ExtendFieldParams {
  addEnabled?: boolean;
  isNeedConfirmation: boolean;
  regex: string;
  optOutEmailText?: string;
  optOutPhoneText?: string;
}

export interface Image {
  imageLink: string;
  imageName: string;
  length: string;
  width: string;
}

export enum LogType {
    ERROR = "[ERROR]",
    WARN = "[WARNING]",
    INFO = "[INFO]",
    DEBUG = "[DEBUG]",
    TRACE = "[TRACE]"
}

export enum LogSource {
  OFFER = "Offers",
  DRAWING = "Drawing",
  GAME = "Game",
  FILTER = "Filter",
  CMS_OFFERS = "CMS Offers",
  PRINT = "Print",
  REDEEM = "Redeem",
  MODAL = "Modal",
  MULTIPLIER = "Multiplier",
  SWAP_OFFER = "Swap Offer",
  BREAK_OFFER = "Break Offer",
  REDEMPTION = "Redemption",
  SYSTEM = "System"
}